import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import useRequest from "../../hooks/useRequest";
import { Link } from "react-router-dom";
import {
  capitalizeFirstLetter,
  downloadExcel1,
  getPermissionDetails,
} from "../../util/fn";
import Pagination from "../Pagination/Pagination";
import { useSelector } from "react-redux";
import Select from "react-select";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { BASEURL } from "../../constant/api";
import axios from "axios";
import { Button } from "react-bootstrap";

const HotDeals = (props) => {
  const [page, setPage] = useState(1);
  const { request: request, response: response } = useRequest();
  const { request: request1, response: response1 } = useRequest();
  const { request: requestCities, response: responseCities } = useRequest();
  const { request: requestUpdate, response: responseDelete } = useRequest();
  const [permission, setPermissions] = useState();
  const { permissions } = useSelector((state) => state.auth);
  const location = useLocation();
  const [data, setData] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [cities, setCities] = useState([]);
  const [outletList, setOutletList] = useState([]);
  const [cityId, setCityId] = useState("");
  const [outletId, setOutletId] = useState("");

  const [columns, setColumns] = useState([
    { title: "S.No." },
    { title: "Outlet" },
    { title: "Action" },
  ]);

  const perPage = 10;
  const [totalDocuments, setTotalDocuments] = useState(10);

  const [search, setSearch] = useState("");
  const [startIndex, setStartIndex] = useState(1);

  useEffect(() => {
    document.title = "Hot Deals - Sportyfy";

    requestCities("GET", `admin/vendor/getCity`);
  }, []);

  useEffect(() => {
    if (cityId) {
      request(
        "GET",
        `admin/vendor/GetAllOutlet?cityId=${cityId}&page=${page}&per_page=${perPage}`
      );
    }
  }, [cityId]);
  useEffect(() => {
    if (responseCities) {
      if (responseCities.status && responseCities.data) {
        setCities(responseCities.data);
      }
    }
  }, [responseCities]);

  useEffect(() => {
    if (response) {
      if (response.status) {
        setData(response.data);
        setTotalDocuments(response.totalDocuments);
      }
    }
  }, [response]);

  const fetchMoreData = ({ selected }) => {
    setPage(selected + 1);
    if (selected + 1 == 1) {
      setStartIndex(1);
    } else {
      setStartIndex(selected * perPage + 1);
    }

    request(
      "GET",
      `admin/vendor/GetAllOutlet?cityId=${cityId}&page=${page}&per_page=${perPage}`
    );
  };

  const handleUpdate = (id,status) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to change Status",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then(function (result) {
      if (result.value) {
        requestUpdate("POST", "admin/vendor/updateHotDeals", {
          outletId: id,
          isHotDeal :status
        });
      }
    });
  };

  useEffect(() => {
    if (responseDelete) {
      if (responseDelete.status) {
        toast.success(responseDelete?.message);
        request(
          "GET",
          `admin/vendor/GetAllOutlet?cityId=${cityId}&page=${page}&per_page=${perPage}`
        );
      }
    }
  }, [responseDelete]);

  useEffect(() => {
    const permissionData = getPermissionDetails(location.pathname, permissions);
    if (permissionData) {
      setPermissions(permissionData);
      if (permissionData?.webAccessEdit) {
        setColumns([...columns, { title: "Action" }]);
      }
    }
  }, []);

  return (
    <div className="ms-content-wrapper">
      <div className="row">
        <div className="col-md-12">
          <Breadcrumb title={"HotDeals"} links={[{ to: "/", name: "Home" }]} />
          <div className="ms-panel">
            <div className="ms-panel-header">
              <div className="row">
                <div className="col-md-2">
                  <h6>{"HotDeals"}</h6>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="cities">City:</label>
                    <Select
                      options={
                        cities &&
                        cities.length > 0 &&
                        cities.map((obj) => ({
                          label: obj.name,
                          value: obj._id,
                        }))
                      }
                      name="cities"
                      onChange={(value) => {
                        setCityId(value.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="ms-panel-body">
              <div className="table-responsive">
                <table className="table table-hover thead-primary">
                  <thead>
                    <tr>
                      {columns &&
                        columns.length > 0 &&
                        columns.map((obj) => <th scope="col">{obj?.title}</th>)}
                    </tr>
                  </thead>
                  <tbody>
                    {data &&
                      data.length > 0 &&
                      data.map((item, i) => (
                        <tr key={item.id}>
                          <th scope="row">{i + startIndex}</th>
                          <td>
                            {item.outletName
                              ? capitalizeFirstLetter(item?.outletName)
                              : ""}
                          </td>

                          <td>
                            <input
                              type="checkbox"
                              checked={item?.isHotDeal == "yes"}
                              onChange={(e) => {
                                handleUpdate(item?.outletId,item?.isHotDeal=='yes'?'no':'yes');
                              }}
                            />
                          </td>
                          {/* )} */}
                        </tr>
                      ))}
                    {data.length == 0 && (
                      <tr>
                        <td colspan="8" style={{ textAlign: "center" }}>
                          {" "}
                          No outlet has found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12">
          {perPage !== 0 &&
            data.length != totalDocuments &&
            data.length !== 0 && (
              <Pagination
                page={page}
                totalDocuments={totalDocuments}
                getNewData={fetchMoreData}
                perPage={perPage}
                currentDocLength={data.length}
              />
            )}
        </div>
      </div>
    </div>
  );
};

export default HotDeals;
